import { Trans, useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import useResponsive from '~/hooks/useResponsive';

import SiteMigrationImage from '../assets/siteMigrationImage.png';

const TransferOptions = () => {
  const { t } = useTranslation('addSites', { keyPrefix: 'migrateSiteOptions' });

  const marketPlaceLink = '/my-account/market-place';

  const { isTablet } = useResponsive();

  return (
    <Container sx={{ marginTop: '16px' }} data-testid="transfer-options-flow">
      <Card
        variant="outlined"
        style={{
          backgroundColor: '#F2F5F7',
          boxShadow: 'none',
        }}
      >
        <Stack
          spacing={1}
          direction={isTablet() ? 'column' : 'row'}
          alignItems="center"
          justifyContent={{ xs: 'center', lg: 'space-between' }}
          margin={2}
        >
          <Stack direction={isTablet() ? 'column' : 'row'} alignItems="center">
            <Box p={3}>
              <CardMedia
                component="img"
                image={SiteMigrationImage}
                alt="Site Migration"
                style={{ height: 100, width: 200, objectFit: 'contain' }}
              />
            </Box>
            <Stack direction="column" spacing={2} alignItems="flex-start">
              <Typography>
                <Trans>{t('payedMigrationDescOne')}</Trans>
              </Typography>
              <Typography>{t('payedMigrationDescTwo')}</Typography>
            </Stack>
          </Stack>
          <Link href={marketPlaceLink} target="_blank">
            <Button variant="outlined" style={{ minWidth: '140px' }}>
              {t('getStarted')}
            </Button>
          </Link>
        </Stack>
      </Card>
    </Container>
  );
};

export default TransferOptions;
